import { useDocumentTitle } from '../hooks/useDocumentTitle';

/**
 * Sets the browser tab title. Renders no DOM.
 *
 * Drop-in replacement for the `<Helmet><title>…</title></Helmet>` blocks on the
 * app pages (sign-in, account, favourites, saved searches). Those pages are not
 * prerendered and are disallowed in robots.txt, so the tab title is the only head
 * value that matters for them — see hooks/useDocumentTitle.ts for why the runtime
 * deliberately owns nothing else.
 *
 * Pages that already compute a full `PageMetadata` should use <SeoHead> instead.
 */
export function DocumentTitle({ title }: { title: string }) {
    useDocumentTitle(title);
    return null;
}
